// extracted by mini-css-extract-plugin
export var content = "_nl-1";
export var noScroll = "_nl-3";
export var paper = "_nl-0";
export var scrollable = "_nl-2";